module.exports = __webpack_public_path__ + "static/media/google_button.c9f7e121.png";